import { render, staticRenderFns } from "./TipsView.vue?vue&type=template&id=d5f3f602&scoped=true"
import script from "./TipsView.vue?vue&type=script&lang=js"
export * from "./TipsView.vue?vue&type=script&lang=js"
import style0 from "./TipsView.vue?vue&type=style&index=0&id=d5f3f602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f3f602",
  null
  
)

export default component.exports